import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export default function TokenProtectedRoute() {
  const { customerLoginInfo, } = useAuthContext();
  return JSON.parse(localStorage.getItem('otp_token')) ? <Outlet /> : <Navigate to="/login" replace />;
}